import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-forward",
  templateUrl: "./med-icon-forward.component.html",
})
export class MedIconForwardComponent extends SvgMixinComponent {}
